<template>
	<div class="group-member-card">
		<head-image :id="member.userId" :name="member.showNickName" :url="member.headImage" :size="40"
			:online="member.online"></head-image>
		<div class="name" :style="isOfficialUser ? 'color:#ff3b30;' : ''">{{ member.showNickName }}<img
                    v-show="isOfficialUser" 
                    class="official-tag" 
                    :src="require('@/assets/image/sticker.gif')" 
                    alt="官方" 
                    title="官方"
                /></div>
		
	</div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";

export default {
	name: "groupMemberCard",
	components: { HeadImage },
	data() {
		return {};
	},
	props: {
		member: {
			type: Object,
			required: true
		}
	},
	computed: {
        isOfficialUser() {
            const list = Array.isArray(this.mine?.officeIds) ? this.mine.officeIds : [];
            const normList = list.map(n => Number(n)).filter(n => !Number.isNaN(n));
            const uid = Number(this.member.userId);
            return !Number.isNaN(uid) && normList.includes(uid);
        },
        mine() {
            return this.userStore.userInfo;
        },
	}
}
</script>

<style lang="scss" scoped>
.group-member-card {
	display: flex;
	flex-direction: column;
	align-items: center;
	min-width: 100px;

	.name {
		font-size: 12px;
		text-align: center;
		width: 100%;
		height: 30px;
		line-height: 30px;
		white-space: nowrap;
		// text-overflow: ellipsis;
		// overflow: hidden
	}
}
</style>
